import React from "react";
import Language from "../Language";


export default function English({children, invert}) {
    return (
        <Language code={"en"} invert={invert}>
            {children}
        </Language>
    )
}
